export default "__VITE_ASSET__Xg0FFOg2__"